import { ChangeEvent } from 'react';
import { DateTime } from 'luxon';

// eslint-disable-next-line import/prefer-default-export,max-len
export const transformToUpperCase = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): string => e.target.value.toUpperCase();

export const transformToUtcTime = (time: string | null | undefined) => {
  if (time) {
    return DateTime.fromISO(time, { zone: 'utc' }).toLocaleString(DateTime.TIME_24_WITH_SHORT_OFFSET);
  }

  return 'Not Available';
};
